(function () {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('ProductErpIntegration', ProductErpIntegration);

    ProductErpIntegration.$inject = ['$resource'];

    function ProductErpIntegration($resource) {
        var resourceUrl = 'api/product-erp-integrations/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllProductLineByProductErpIntegration': {
                method: 'GET',
                isArray: true,
                url: 'api/product-erp-integration/findAllProductLineByProductErpIntegration'
            },
            'findAllPriceLineByProductErpIntegration': {
                method: 'GET',
                isArray: true,
                url: 'api/product-erp-integration/findAllPriceLineByProductErpIntegration'
            }
        });
    }
})();
